import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertDialogDescription } from "@radix-ui/react-alert-dialog";
import { UseMutationResult } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface PayrollTypeDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  payrollTypeName: string;
  deleteMutation: UseMutationResult<void, Error, void, unknown>;
}

const PayrollTypeDeleteDialog = ({
  open,
  onOpenChange,
  payrollTypeName,
  deleteMutation,
}: PayrollTypeDeleteDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("payrollTypes.delete.title")}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          {t("payrollTypes.delete.description")}
          <br />
          <p>
            {t("payrollTypes.fields.name")}:<strong> {payrollTypeName}</strong>
          </p>
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("payrollTypes.delete.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => deleteMutation.mutate()}
            disabled={deleteMutation.isPending}
          >
            {t("payrollTypes.delete.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PayrollTypeDeleteDialog;
